import React from 'react';
interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}
export function StethoscopeIcon({
  className = 'w-8 h-8',
  ...props
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...props} data-id="element-254">
      <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3" data-id="element-255" />
      <path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4" data-id="element-256" />
      <circle cx="20" cy="10" r="2" data-id="element-257" />
    </svg>;
}
export function CarIcon({
  className = 'w-8 h-8',
  ...props
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...props} data-id="element-258">
      <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" data-id="element-259" />
      <circle cx="7" cy="17" r="2" data-id="element-260" />
      <path d="M9 17h6" data-id="element-261" />
      <circle cx="17" cy="17" r="2" data-id="element-262" />
    </svg>;
}
export function ShieldIcon({
  className = 'w-8 h-8',
  ...props
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...props} data-id="element-263">
      <path d="M20 13c0 5-3.5 9-8 10-4.5-1-8-5-8-10V5l8-3 8 3v8Z" data-id="element-264" />
    </svg>;
}
export function RocketIcon({
  className = 'w-8 h-8',
  ...props
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...props} data-id="element-265">
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" data-id="element-266" />
      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" data-id="element-267" />
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" data-id="element-268" />
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" data-id="element-269" />
    </svg>;
}